/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2BackIcon16Solid = forwardRef('MediaUiASkip2BackIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M0 3.5a1 1 0 0 1 2 0v3.056l4.939-3.567C7.799 2.368 9 2.982 9 4.042v2.514l4.939-3.567C14.799 2.368 16 2.982 16 4.042v7.915c0 1.061-1.201 1.675-2.061 1.054L9 9.444v2.513c0 1.061-1.201 1.675-2.061 1.054L2 9.444V12.5a1 1 0 1 1-2 0v-9Z" })));
});
